import { useState, useEffect } from "react";

import style from "./CreareInterviu.module.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import axios from "axios";

import { API_URL } from "../../../const";

import { Toaster, toast } from "react-hot-toast";

import { FaAngleDown, FaPencilAlt, FaTrashAlt, FaAngleUp } from "react-icons/fa";

import InterviewModal from "../../../Components/Admin/InterviewModal/InterviewModal";

function CreareInterviu() {
    const [data, setData] = useState(new Date());
    const [nrLocuri, setNrLocuri] = useState(0);
    const [intervale, setIntervale] = useState([]);
    const [acordeonActiv, setAcordeonActiv] = useState(null);
    const [fetch, setFetch] = useState(false);
    const [afiseazaModala, setAfiseazaModala] = useState(false);
    const [interviuSelectat, setInterviuSelectat] = useState(null);
    useEffect(() => {
        const loadInterviewsArray = async (interviewsArray) => {
            try {
                  let newArray = [];
                  for (let elem of interviewsArray) {
                    let newHoursArray = [];
                    for (let o of elem.ore){
                         const nrUseri = await axios.get(`${API_URL}/api/interview/users/${o.id}`);
                         console.log( nrUseri.data.length);
                         newHoursArray.push({info: o,
                        nrLocuriOcupate: nrUseri.data.length});
                    }
                    newArray.push({
                        date: elem.date,
                        ore: newHoursArray
                      });
                  } 
                    console.log(newArray);
                    return newArray;
                   
            }
            catch(err){
                console.log(err);
            }
        }
        const fetchInterviews = async () => {
            try {
                const interviuri = await axios.get(`${API_URL}/api/interview`);
                const interviuriGrupate = Object.groupBy(interviuri.data, (i) => {
                    let data = new Date(i.date);
                    return data.toLocaleString('ro-RO', {
                        weekday: "long",
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                    })
                });
                let interviewsArray = Object.entries(interviuriGrupate).map(([data, array]) => {
                    return {
                        date: data,
                        ore: array
                    }
                });
              let newInterviewsArray = await loadInterviewsArray(interviewsArray);
                console.log(newInterviewsArray);
                setIntervale(newInterviewsArray);

            } catch (err) {
                console.log(err);
            }
        }
        fetchInterviews();
        setFetch(false);
    }, [fetch])
    async function handleSubmit() {
        console.log(data, nrLocuri);
        try {
            const res = await axios.post(
                `${API_URL}/api/interview`,
                {
                    date: data,
                    availableSpots: Number(nrLocuri)
                }
            );
            toast.success("Interviul a fost creat cu succes!");
            setFetch(true);
        } catch (err) {
            toast.error("Eroare la crearea interviului. Există deja un interviu programat la aceeași dată și oră.");
        }
    }

    async function deleteInterview(o){
        try {
            await axios.delete(`${API_URL}/api/interview/${o.info.id}`);
            setFetch(true);
        } catch(err){
            console.log(err);
            toast.error("Nu s-a putut șterge interviul");
        }
    }

    function toggleShow(i){
       if(acordeonActiv === i.date) setAcordeonActiv(null);
       else setAcordeonActiv(i.date);
    }

    function toggleModala(i){
        if(!afiseazaModala) {
           setAfiseazaModala(true);
            setInterviuSelectat(i);
        }
        else setAfiseazaModala(false);
          console.log(afiseazaModala);
    }

    return (
        <>
            <div className={style.pickerWrapper}>
                <div className={style.create}>
                    <h1>Creează interviu nou</h1>
                    <div className={style.form}>
                        <div className={style.formInput}>
                            <p>Alege data și ora pentru interviu:</p>
                            <div className={style.datepicker}><DatePicker wrapperclassName={style.datepicker} value={data} selected={data} onChange={(d) => setData(d)} showTimeSelect timeIntervals={30} timeFormat="HH:mm" dateFormat="dd.MM.yyyy HH:mm"></DatePicker></div>
                        </div>
                        <div className={style.formInput}>
                            <label htmlFor="nr">Completează numărul de locuri alocate:</label>
                            <input id="nr" name="nr" type="text" value={nrLocuri} onChange={(l) => setNrLocuri(l.target.value)}></input>
                        </div>
                    </div>
                    <button className={style.submitBtn} onClick={() => handleSubmit()}>OK</button>
                </div>
                <div className={style.create}>
                    <h1>Interviuri existente:</h1>
                    <div className={style.acordeonWrapper}>
                    {intervale.map((i) => {
                        return (<div className={style.containerAcordeon}>
                            <button className={acordeonActiv === i.date ? `${style.acordeon}` : `${style.acordeonInactiv}`} onClick={() => toggleShow(i)}>{i.date} {acordeonActiv === i.date ? <FaAngleUp></FaAngleUp>: <FaAngleDown></FaAngleDown>}</button>
                            {acordeonActiv === i.date ? <div className={style.panel}>{i.ore.map((o) => {
                                return  (<div className={style.rand}><div className={style.randText}>{new Date(o.info.date).toLocaleString("ro-RO", { hour: "2-digit", minute: "2-digit" })} - {o.nrLocuriOcupate}/{o.info.availableSpots + o.nrLocuriOcupate} {window.innerWidth >= 750 ? "locuri ocupate" : null}</div>
                                <div className={style.containerButoane}>
                                    <button className={style.action} onClick = {() => toggleModala(o)}><FaPencilAlt></FaPencilAlt></button>
                                    <button className={style.action} onClick={() => deleteInterview(o)}><FaTrashAlt></FaTrashAlt></button>
                                </div>
                            </div>);
                            })}
                        </div> : null }</div>);
                    })}
                    </div>
                </div>
            </div>
                    {afiseazaModala ? <InterviewModal interval = {interviuSelectat} setFetch={setFetch} setAfiseazaModala={setAfiseazaModala}/> : null}
            <Toaster />
        </>);
}

export default CreareInterviu;